import { graphql } from 'react-relay';

export const ItemFragment = graphql`
    fragment ItemFragment on ListItem {
        id
        name
        code
        description
        child
        type
        parent
        link_id
    }
`;
